import React from 'react';
import { PainSection } from './PainSection';
import { ProductIntro } from './ProductIntro';
import { TomosSection } from './TomosSection';
import { BonosSection } from './BonosSection';
import { ValueStack } from './ValueStack';
import { AudienceSection } from './AudienceSection';
import { Testimonials } from './Testimonials';
import { HowItWorks } from './HowItWorks';
import { Guarantee } from './Guarantee';
import { ClosingBlock } from './ClosingBlock';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
import { SocialProofPopup } from './SocialProofPopup';
import { FloatingCTA } from './FloatingCTA';
export function DeferredLanding() {
  return <>
      <PainSection data-id="element-51" data-mp="x0wz342uwpm2" />
      <ProductIntro data-id="element-52" data-mp="x0dgrm9anz7i" />
      <TomosSection data-id="element-53" data-mp="x16pgsrtcysa" />
      <BonosSection data-id="element-54" data-mp="x2q4kg1qh3sh" />
      <ValueStack data-id="element-55" data-mp="1bxxhggz5r87v" />
      <AudienceSection data-id="element-56" data-mp="1bxe47dkgd806" />
      <Testimonials data-id="element-57" data-mp="1bypd1rsr95y5" />
      <HowItWorks data-id="element-58" data-mp="1by5v4b33uhk4" />
      <Guarantee data-id="element-59" data-mp="1bvjoqerya83h" />
      <ClosingBlock data-id="element-60" data-mp="16z2ud2u5qxhy" />
      <FAQ data-id="element-61" data-mp="16zvwtrm330ua" />
      <Footer data-id="element-62" data-mp="17047dcuqhu2b" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-63" data-mp="170nt74ni92lm" />
      <SocialProofPopup data-id="element-64" data-mp="1xxozkrmfn91m" />
      <FloatingCTA data-id="element-65" data-mp="1xyhxd33eyo7m" />
    </>;
}